import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Success, Error, Warning } from "../ui/toaster";
import generateAction from "../../utils/action-helpers";
import { MESSAGES } from "../../state/actions";
import { messageState } from "../../utils/messajes";

const Messages = React.memo(() => {
  const dispatch = useDispatch();
  const { fileStatus, uploadStatus } = useSelector(state => state.messages);
  const [messageError, setMessageError] = useState(fileStatus === messageState.ERROR);
  const [uploadSuccess, setUploadSuccess] = useState(uploadStatus === messageState.SUCCESS);
  const [uploadError, setUploadError] = useState(uploadStatus === messageState.ERROR);
  const [uploadWarning, setUploadWarning] = useState(uploadStatus === messageState.WARNING);
  useEffect(() => {
    setMessageError(fileStatus === messageState.ERROR);
  }, [fileStatus]);
  useEffect(() => {
    setUploadError(uploadStatus === messageState.ERROR);
    setUploadSuccess(uploadStatus === messageState.SUCCESS);
    setUploadWarning(uploadStatus === messageState.WARNING);
  }, [uploadStatus]);

  const updateFileStatus = () => dispatch(generateAction(MESSAGES.FILE_STATUS, messageState.IDLE));
  const updateUploadStatus = () =>
    dispatch(generateAction(MESSAGES.UPLOAD_STATUS, messageState.IDLE));

  return (
    <div>
      <Error
        id="file-error"
        visible={messageError}
        title="Error en la carga"
        text="Ha ocurrido un error al recuperar los ficheros"
        onClose={updateFileStatus}
      />
      <Error
        id="delete_error"
        visible={uploadError}
        title="Operacion cancelada"
        text="Ha ocurrido un error en la subida del fichero."
        onClose={updateUploadStatus}
      />
      <Success
        id="delete_success"
        visible={uploadSuccess}
        title="Operación completada"
        text="Se ha subido el fichero con exito"
        onClose={updateUploadStatus}
      />
      <Warning
        id="upload_warning"
        visible={uploadWarning}
        title="Fichero invalido"
        text="El formato de fichero no es el correcto (xls, xlsx)"
        onClose={updateUploadStatus}
      />
    </div>
  );
});

export default Messages;
